import { render, staticRenderFns } from "./AwardOptionsForm.vue?vue&type=template&id=1f4bc7a5&scoped=true"
import script from "./AwardOptionsForm.vue?vue&type=script&lang=js"
export * from "./AwardOptionsForm.vue?vue&type=script&lang=js"
import style0 from "./AwardOptionsForm.vue?vue&type=style&index=0&id=1f4bc7a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bc7a5",
  null
  
)

export default component.exports